/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseId200,
  GetApiV1CourseId401,
  GetApiV1CourseId404,
  GetApiV1CourseId500,
  GetApiV1CourseIdPathParams,
  GetApiV1CourseIdQueryResponse,
} from "../../types/courseRegistrationController/GetApiV1CourseId.ts";
import { courseDetailViewModelSchema } from "../courseDetailViewModelSchema.ts";

export const getApiV1CourseIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1CourseIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseId200Schema = z.lazy(
  () => courseDetailViewModelSchema,
) as unknown as ToZod<GetApiV1CourseId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseId401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1CourseId404Schema =
  z.any() as unknown as ToZod<GetApiV1CourseId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseId500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseId500>;

export const getApiV1CourseIdQueryResponseSchema = z.lazy(
  () => getApiV1CourseId200Schema,
) as unknown as ToZod<GetApiV1CourseIdQueryResponse>;
